import React, {Component} from 'react';

import Popup from '../Popup/index';

import {smileys} from '../../../constants/chatEditorOwn';
import {uniqueId} from '../../../utils'

class ChatEditorSmilePopup extends Popup {
    constructor(props) {
        super(props);

        this.moveableAnchor = false;

        this.insertSmile = this.insertSmile.bind(this);

      //  if (this.props.ref) {
      //      this.props.ref(this);
      //  }
    }

    position() {
        if (!this.$anchor || this.$anchor.length === 0) return;

        var offset = this.$anchor.offset(),
            width = this.$popup.width(),
            height = this.$popup.height();

        this.$popup.css({
            left: (offset.left - width) + "px",
            top: (offset.top - height - 16) + "px"
        });
    }

    insertSmile(smiley) {
        this.props.insertSmileFn(smiley);
        this.close();
    }

    render() {
        let className = 'popup block-smiley ' + this.state.visibility;

        return (
            <div className={className} ref={(ref) => this._ref = ref}>
                {smileys.map((smiley) =>
                    <a key={smiley.desc} tabIndex="-1" onClick={() => this.insertSmile(smiley)}>
                        <span title={smiley.desc} >{smiley.emoji}</span>
                    </a>
                )}
            </div>
        )
    }

}

ChatEditorSmilePopup.generateKey = function(props) {
    return 'pm-editor-smile-popup-' + uniqueId();
};
ChatEditorSmilePopup.mount = function(props) { return Popup.mount(ChatEditorSmilePopup, props) };
ChatEditorSmilePopup.unmount = function(props) { return Popup.unmount(ChatEditorSmilePopup, props) };

export default ChatEditorSmilePopup;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ChatEditorSmilePopup/index.js